/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
export * from "./BaseChange";
export * from "./BaseChangeList";
export * from "./ChangeKey";
export * from "./ChangeKeyList";
export * from "./CountryLocation";
export * from "./Location";
export * from "./SPDomainKey";
export * from "./SpServiceDomainKey";
export * from "./Term";
export * from "./TermChange";
export * from "./TermChangeList";
export * from "./TermDomainKey";
export * from "./TermList";
